import { useEffect, useState } from "react";

export function usePrefersReducedMotion() {
    const [reduced, setReduced] = useState(() => {
        if (typeof window !== 'undefined') {
            return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        }
        return false;
    });

    useEffect(() => {
        if (typeof window === 'undefined') return;

        const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

        const handleChange = (e: MediaQueryListEvent) => {
            setReduced(e.matches);
        };

        setReduced(mediaQuery.matches);

        mediaQuery.addEventListener("change", handleChange);

        return () => {
            mediaQuery.removeEventListener("change", handleChange);
        };
    }, []);

    return reduced;
}
